import { useRef, useState } from "react";

export default function UploadDropzone({
    onFilesChange,
}: {
    onFilesChange: (files: File[]) => void;
}) {
    const inputRef = useRef<HTMLInputElement | null>(null);
    const [files, setFiles] = useState<File[]>([]);
    const [previewImage, setPreviewImage] = useState<string | null>(null);
    const [isDragging, setIsDragging] = useState(false);

    const handleClick = () => {
        if (files.length >= 1) return;
        inputRef.current?.click();
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFiles = e.target.files;
        if (!selectedFiles) return;

        const newFiles = Array.from(selectedFiles);
        const totalFiles = files.length + newFiles.length;

        if (totalFiles > 1) {
            alert("Chỉ được tải tối đa 1 hình");
            return;
        }

        const next = [...files, ...newFiles];
        setFiles(next);
        onFilesChange(next);
        e.target.value = ""; // reset để chọn lại cùng file
    };

    const handleAddFiles = (fileList: FileList) => {
        const newFiles = Array.from(fileList);
        const totalFiles = files.length + newFiles.length;

        if (totalFiles > 1) {
            alert("Chỉ được tải tối đa 1 hình");
            return;
        }

        const next = [...files, ...newFiles];
        setFiles(next);
        onFilesChange(next);
    };

    return (
        <>
            {/* PREVIEW HÌNH – HIỂN THỊ PHÍA TRÊN */}
            {files.length > 0 && (
                <div
                    style={{
                        display: "flex",
                        gap: "10px",
                        marginBottom: "10px",
                        flexWrap: "wrap",
                    }}
                >
                    {files.map((file, index) => (
                        <div
                            key={index}
                            style={{
                                position: "relative",
                                width: "90px",
                                height: "90px",
                            }}
                        >
                            {/* ICON X */}
                            <div
                                onClick={() => {
                                    const next = files.filter((_, i) => i !== index);
                                    setFiles(next);
                                    onFilesChange(next);
                                }}
                                style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "-6px",
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "50%",
                                    background: "#000",
                                    color: "#fff",
                                    fontSize: "14px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    zIndex: 2,
                                }}
                            >
                                ×
                            </div>

                            {/* IMAGE */}
                            <img
                                src={URL.createObjectURL(file)}
                                alt=""
                                onClick={() => setPreviewImage(URL.createObjectURL(file))}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    borderRadius: "6px",
                                    border: "1px solid #e2e2e1",
                                    cursor: "zoom-in",
                                }}
                            />
                        </div>
                    ))}
                </div>
            )}

            {/* DROPZONE – GIỮ NGUYÊN CLASS */}
            <div
                tabIndex={0}
                className="style_dropzone__U4yHJ"
                onClick={handleClick}
                onDragOver={e => {
                    e.preventDefault();
                    setIsDragging(true);
                }}
                onDragLeave={() => setIsDragging(false)}
                onDrop={e => {
                    e.preventDefault();
                    setIsDragging(false);
                    if (e.dataTransfer.files.length > 0) {
                        handleAddFiles(e.dataTransfer.files);
                    }
                }}
                style={{
                    cursor: files.length >= 1 ? "not-allowed" : "pointer",
                    opacity: files.length >= 1 ? 0.6 : 1,
                    border: isDragging ? "2px dashed #1890ff" : undefined,
                    background: isDragging ? "rgba(24,144,255,0.05)" : undefined,
                }}
            >
                <input
                    ref={inputRef}
                    type="file"
                    accept="image/png,image/jpeg,image/jpg"
                    autoComplete="off"
                    tabIndex={-1}
                    style={{ display: "none" }}
                    onChange={handleChange}
                />

                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <span style={{ boxSizing: "border-box", display: "inline-block", overflow: "hidden", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", position: "relative", maxWidth: "100%" }}>
                        <span style={{ boxSizing: "border-box", display: "block", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", maxWidth: "100%" }}>
                            <img alt="" aria-hidden="true" src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2713%27%20height=%2716%27/%3e" style={{ display: "block", maxWidth: "100%", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px" }} />
                        </span>
                        <img data-origin-url="https://cdn-web-next.thuocsi.vn/images/icon/add_file.png" src="https://cdn-web-next.thuocsi.vn/images/icon/add_file.png" decoding="async" data-nimg="intrinsic" style={{ position: "absolute", inset: "0px", boxSizing: "border-box", padding: "0px", border: "none", margin: "auto", display: "block", width: "0px", height: "0px", minWidth: "100%", maxWidth: "100%", minHeight: "100%", maxHeight: "100%" }} />
                    </span>
                    <p
                        className="MuiTypography-root MuiTypography-body1"
                        style={{ marginLeft: "14px", fontSize: "12px" }}
                    >
                        Kéo thả file vào đây
                    </p>
                </div>

                <p
                    className="MuiTypography-root MuiTypography-body1"
                    style={{ fontSize: "12px" }}
                >
                    File PNG, JPEG, JPG - tối đa 1 file
                </p>
            </div>
            {previewImage && (
                <div
                    onClick={() => setPreviewImage(null)}
                    style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(0,0,0,0.75)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999,
                        cursor: "zoom-out",
                    }}
                >
                    <img
                        src={previewImage}
                        alt=""
                        onClick={e => e.stopPropagation()}
                        style={{
                            maxWidth: "90%",
                            maxHeight: "90%",
                            borderRadius: "8px",
                            background: "#fff",
                        }}
                    />

                    {/* Nút X */}
                    <div
                        onClick={() => setPreviewImage(null)}
                        style={{
                            position: "fixed",
                            top: "20px",
                            right: "24px",
                            color: "#fff",
                            fontSize: "28px",
                            cursor: "pointer",
                        }}
                    >
                        ×
                    </div>
                </div>
            )}
        </>
    );
}
